<main class="home-page" aria-label="Configurator">
  <header class="workspace-heading">
    <div>
      <p class="workspace-eyebrow">CONVERSION CONFIGURATOR</p>
      <h1>{{ provisionService.getProvision().Name || 'Provision workspace' }}</h1>
      <p class="workspace-help">Edit your provision, analyze the changes and save after a successful analysis.</p>
    </div>
    <span class="workspace-status" [class.workspace-status--pending]="provisionService.hasPendingChanges()" role="status">
      {{ provisionService.hasPendingChanges() ? 'Unsaved changes' : provisionPanel.showSaveConfirmation ? 'Saved' : 'No unsaved changes' }}
    </span>
  </header>
  <section class="home-panel workspace-provision" aria-labelledby="provision-title">
    <header class="home-panel__header">
      <tds-icon name="document" size="24px" aria-hidden="true"></tds-icon>
      <h2 class="home-panel__title" id="provision-title">Provision</h2>
    </header>
    <div class="home-panel__body"><conversion-provision #provisionPanel></conversion-provision></div>
  </section>
  <div class="home-grid">
    <div class="home-column">
      <section class="home-panel" aria-labelledby="configuration-title">
        <header class="home-panel__header">
          <tds-icon name="settings" size="24px" aria-hidden="true"></tds-icon>
          <h2 class="home-panel__title" id="configuration-title">Configuration</h2>
        </header>
        <div class="home-panel__body" [attr.inert]="provisionBusy ? '' : null" [attr.aria-busy]="provisionBusy">
          <conversion-configuration></conversion-configuration>
        </div>
      </section>
      <section class="home-panel" aria-labelledby="analysis-settings-title">
        <header class="home-panel__header">
          <tds-icon name="insights" size="24px" aria-hidden="true"></tds-icon>
          <h2 class="home-panel__title" id="analysis-settings-title">Analysis settings</h2>
        </header>
        <div class="home-panel__body" [attr.inert]="provisionBusy ? '' : null">
          <conversion-breakdown></conversion-breakdown>
        </div>
      </section>
    </div>
    <section class="home-panel" aria-labelledby="changes-title">
      <header class="home-panel__header">
        <tds-icon name="sorting" size="24px" aria-hidden="true"></tds-icon>
        <h2 class="home-panel__title" id="changes-title">Changes and analysis</h2>
        <span class="workspace-status workspace-status--pending" *ngIf="provisionService.hasPendingChanges()">
          {{ provisionService.pendingFpcCount + (provisionService.hasPartPeriodChanges() ? 1 : 0) }} pending
        </span>
      </header>
      <div class="home-panel__body" [attr.inert]="provisionBusy ? '' : null" [attr.aria-busy]="provisionBusy">
        <conversion-changes #changesPanel></conversion-changes>
      </div>
    </section>
  </div>
  <footer class="workspace-actions" aria-label="Provision actions">
    <div role="status" aria-live="polite">
      <strong>{{ provisionBusy ? 'Updating provision…' : provisionService.hasPendingChanges() ? 'Unsaved changes' : provisionPanel.showSaveConfirmation ? 'All changes saved' : 'No unsaved changes' }}</strong>
      <p *ngIf="provisionService.hasPendingChanges()">{{ provisionService.pendingFpcCount }} FPC changes{{ provisionService.hasPartPeriodChanges() ? ' + part period' : '' }} · Save all provision changes together</p>
      <p *ngIf="provisionService.hasPendingChanges() && !provisionBusy">{{ changesPanel.tcrvcrRunning ? 'Analysis in progress…' : provisionService.isAnalysisSuccessful() ? 'Analysis OK. Ready to save.' : 'Analyze successfully to enable Save changes.' }}</p>
      <p *ngIf="!provisionService.hasPendingChanges()">{{ provisionPanel.lastSaved ? 'Last saved ' + (provisionPanel.lastSaved | date:'HH:mm') + ' · Continue editing this provision' : 'Changes from all panels appear here' }}</p>
    </div>
    <div class="workspace-actions__buttons">
      <tds-button type="button" variant="secondary" [disabled]="!changesPanel.canAnalyze" (click)="changesPanel.validateProvision()"
        [text]="changesPanel.tcrvcrRunning ? 'Analyzing…' : 'Analyze'"></tds-button>
      <tds-button type="button" variant="primary" [disabled]="!provisionPanel.canSave" (click)="provisionPanel.saveProvision()"
        [text]="provisionPanel.provisionSaving ? 'Saving…' : 'Save changes'"></tds-button>
    </div>
  </footer>
</main>
